import PropTypes from 'prop-types';
import { Component } from 'react';
import Flux from '../../../flux/Flux';

function withGalleryRatings(T) {
	class GalleryRatings extends Component {
		constructor(props) {
			super(props);

			this.state = {
				album: this.props.album,
			};

			this.galleryRatingChangeHandler = this.galleryRatingChangeHandler.bind(this);
		}

		componentDidMount() {
			Flux.Gallery.addGalleryRatingChangeListener(this.galleryRatingChangeHandler);
		}

		componentDidUpdate(prevProps) {
			if (prevProps.album !== this.props.album) {
				this.setState({ album: this.props.album });
			}
		}

		componentWillUnmount() {
			Flux.Gallery.removeGalleryRatingChangeListener(this.galleryRatingChangeHandler);
		}

		/**
		 * @param {number} actorId
		 * @param {number} albumId
		 */
		galleryRatingChangeHandler(actorId, albumId) {
			if (actorId !== this.props.actor.id && albumId !== this.props.album.id) {
				return;
			}

			const data = this.props.isSedcard ? Flux.Gallery.getSedcards(this.props.actor.id) : Flux.Gallery.getGalleryData(this.props.album.id);

			const upd = {
				likes: data.guestRatingLikes,
				dislikes: data.guestRatingDislikes,
				totalViews: data.albumTotalViews,
				isLiked: data.isLiked,
				isDisliked: data.isDisliked,
			};

			const { album } = this.state;
			this.setState({
				album: { ...album, ...upd },
			});
		}

		render() {
			const mergedProps = { ...this.props, ...this.state };
			return <T {...mergedProps} />;
		}
	}

	GalleryRatings.propTypes = {
		album: PropTypes.shape({
			id: PropTypes.number,
			description: PropTypes.string,
			contestPlace: PropTypes.number,
			releaseDate: PropTypes.string,
			duration: PropTypes.string,
			hasAudio: PropTypes.bool,
			totalViews: PropTypes.number,
			title: PropTypes.string,
			contestDetailsUrl: PropTypes.string,
			likes: PropTypes.number,
			dislikes: PropTypes.number,
			isLiked: PropTypes.bool,
			isDisliked: PropTypes.bool,
			isFavorite: PropTypes.bool,
			isVotingVisible: PropTypes.bool,
			areCommentsVisible: PropTypes.bool,
		}),
		actor: PropTypes.shape({
			id: PropTypes.number,
		}),
		isSedcard: PropTypes.bool,
	};

	return GalleryRatings;
}

export default withGalleryRatings;
